import {
  type TCalendarPreviewHeaderProps,
} from "@/ui/components/form/Calendar/CalendarPreview.config";
import { TextBody } from "@/ui/components/typography/TextBody";
import { TextControl } from "@/ui/components/typography/TextControl";

export const CalendarPreviewHeader = ({
  date,
  title,
}: TCalendarPreviewHeaderProps) => (
  <TextBody
    tag="div"
    size={3}
    isResponsive={false}
    data-component="CalendarPreviewHeader"
  >
    { title }:{ " " }
    <TextControl tag="strong" size={3} isResponsive={false}>
      { date }
    </TextControl>
  </TextBody>
);

CalendarPreviewHeader.displayName = "CalendarPreviewHeader";
